import { cn } from '@/lib/utils';

/** Lỗi ở chỗ phát sinh (design system v4): băng `role="alert"` có Thử lại, thay cho toast.error. Toast chỉ báo thành công. */
export function InlineError({ message, onRetry, className }: { message: string; onRetry?: () => void; className?: string }) {
  return (
    <p role="alert" className={cn('flex flex-wrap items-center gap-x-2 rounded-lg bg-destructive-soft px-3 py-2 text-sm text-destructive-ink', className)}>
      {message}
      {onRetry && <button type="button" className="font-medium underline" onClick={onRetry}>Thử lại</button>}
    </p>
  );
}

/** Khung chờ cho một khối đang tải (thay chữ "Đang tải…"). */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-busy="true" aria-label="Đang tải" className={cn('h-40 animate-pulse rounded-xl bg-muted', className)} />;
}
